export default class Installment {
    constructor(){
        this.quantity = 1;
        this.value = 0.0;
        this.noInterestInstallmentQuantity = 0;
    }
}